import React from 'react'

import { Card, Group, Main, Name, Number } from './style'

const AboutDevelopersCard = ({ developer }) => (
    <Card>
        <Number>{developer.id}</Number>
        <Main>
            <Name>{developer.fullName}</Name>
            {developer.group && (
                <Group>Группа: {developer.group}</Group>
            )}
        </Main>
    </Card>
)

export default AboutDevelopersCard
